import { Card, CardContent } from '~/scalis-components/core'

interface ApprovalStepCardProps {
  title: string
  subTitle: React.ReactNode
  description: string
  children: React.ReactNode
}

export function ApprovalStepCard({ title, subTitle, description, children }: ApprovalStepCardProps) {
  return (
    <Card className='@container'>
      <CardContent>
        <div className='flex flex-col items-start gap-2'>
          <div>
            <div className='flex items-center gap-1'>
              <p className='body-small-bold text-neutral-primary'>{`${title}:`}</p>
              {subTitle}
            </div>

            <p className='body-small-basic text-neutral-secondary'>{description}</p>
          </div>
          <div className='w-full'>{children}</div>
        </div>
      </CardContent>
    </Card>
  )
}
